import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GiphyService {
  private apiKey = 'M2TBfFnI3uiVnHLkyrZ47NjTSn0w4Ds3'; // Replace with your actual API key
  private apiUrl = 'https://api.giphy.com/v1/gifs/search';

  constructor(private http: HttpClient) {}

  searchGifs(query: string, offset: number = 0): Observable<any> {
    const params = {
      api_key: this.apiKey,
      q: query,
      limit: '20',
      offset: offset.toString(), // Use the offset for pagination
    };

    return this.http.get(this.apiUrl, { params });
  }

  addGif(url: string): Promise<ArrayBuffer | undefined> {
    return this.http
      .get(
        'https://media3.giphy.com/media/gw3IWyGkC0rsazTi/100.gif?cid=fc15f819gyhekp5fs2u2hr99lue5ftxsa48f0frmxrqgtde6&ep=v1_gifs_search&rid=100.gif&ct=g',
        { responseType: 'arraybuffer' }
      )
      .toPromise();
  }
}
